import { render, staticRenderFns } from "./peiBuAdd.vue?vue&type=template&id=2227292f&scoped=true&"
import script from "./peiBuAdd.vue?vue&type=script&lang=js&"
export * from "./peiBuAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2227292f",
  null
  
)

export default component.exports